export const isExternal = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url, window.location.origin);
    return parsedUrl.origin !== window.location.origin;
  } catch {
    return false; // If the URL is invalid, assume it's not external
  }
};
